import { render, staticRenderFns } from "./HeaderEmpty.vue?vue&type=template&id=2bb6e9f7&"
import script from "./HeaderEmpty.vue?vue&type=script&lang=js&"
export * from "./HeaderEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports